// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperSelector-cls1_Z4a","cls2":"PaperSelector-cls2_awT PaperSelector-cls1_Z4a"};